import React from 'react';
import { Button } from 'semantic-ui-react';
import ValidateDataModelRowButton from './ValidateDataModelRowButton';

const DataManagementDataModelButtonGroup = ({
  disableValidate,
  size = 'mini',
  validate,
}) => (
  <Button.Group
    basic
    size={size}
    icon
    compact
  >
    <ValidateDataModelRowButton
      onClick={() => (validate())}
      disabled={disableValidate}
    />
  </Button.Group>
);

export default DataManagementDataModelButtonGroup;
